/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react'

import { Image } from '../../components'
import CtaButton from '../../components/CtaButton/CtaButton'
import { Content } from '../../components/Typography'
import { SectionContainer } from '../../layouts'
import {
  ALLOWED_WORDS,
  ContentParser,
  hasNulls,
  notEmpty,
  replaceWordInString,
} from '../../utils/helpers'
import {
  btnClassName,
  carouselStyling,
  doubledImage,
  doubledSlide,
  headingContainerStyling,
  slideImage,
  swiperSlide,
} from './TreatmentResultSection.module.css'

const CONTENT_TRESHOLD = 2

const TreatmentResultSection = ({ lang, slice }) => {
  const {
    doubledpictures,
    textarea,
    treatmentresultkicker,
    treatmentresulttitle,
  } = slice
  const [showMore, setShowMore] = useState(true)
  const results = ContentParser(slice, 'treatmentresult')
  const slides = doubledpictures
    ? results
        .slice(2)
        .map((item) => item.beforetreatmentimage)
        .filter(notEmpty)
    : results.filter((res) => !hasNulls(Object.values(res))).slice(2)
  const slidesToShow = showMore ? CONTENT_TRESHOLD : slides.length
  const btnLabel = showMore ? 'Show more' : 'Show less'

  if (slides.length === 0) {
    return (
      <SectionContainer
        extraHeadingContainerClassName={headingContainerStyling}
        heading={replaceWordInString(
          treatmentresulttitle,
          'botox',
          ALLOWED_WORDS[lang],
        )}
        kicker={replaceWordInString(
          treatmentresultkicker,
          'botox',
          ALLOWED_WORDS[lang],
        )}
        withHeader
      >
        <div className={carouselStyling}>
          {textarea && <Content renderContent={textarea} />}
        </div>
      </SectionContainer>
    )
  }

  const showMoreHandler = () => {
    setShowMore(!showMore)
  }

  return (
    <SectionContainer
      extraHeadingContainerClassName={headingContainerStyling}
      heading={replaceWordInString(
        treatmentresulttitle,
        'botox',
        ALLOWED_WORDS[lang],
      )}
      kicker={replaceWordInString(
        treatmentresultkicker,
        'botox',
        ALLOWED_WORDS[lang],
      )}
      withHeader
    >
      <div className={carouselStyling}>
        {textarea && <Content renderContent={textarea} />}
        {slides.length > 0 &&
          slides.slice(0, slidesToShow).map((result, index) => {
            const { aftertreatmentimage, beforetreatmentimage } = result
            if (!doubledpictures)
              return (
                <div
                  key={index}
                  className={swiperSlide}
                  role="button"
                  tabIndex="0"
                >
                  {beforetreatmentimage && (
                    <Image
                      alt={beforetreatmentimage.altText || 'EA Kliniken'}
                      className={slideImage}
                      src={beforetreatmentimage.node.localFile.childImageSharp}
                    />
                  )}
                  {aftertreatmentimage && (
                    <Image
                      alt={aftertreatmentimage.altText || 'EA Kliniken'}
                      className={`${slideImage}`}
                      src={aftertreatmentimage.node.localFile.childImageSharp}
                    />
                  )}
                </div>
              )

            return (
              <div
                key={index}
                className={doubledSlide}
                role="button"
                tabIndex="0"
              >
                {result && (
                  <Image
                    alt={result.altText || 'EA Kliniken'}
                    className={doubledImage}
                    src={result.node.localFile.childImageSharp}
                  />
                )}
              </div>
            )
          })}
      </div>
      {slides.length > CONTENT_TRESHOLD && (
        <CtaButton
          extraClassName={btnClassName}
          onClick={showMoreHandler}
          title={btnLabel}
          type="primary"
          wide
        />
      )}
    </SectionContainer>
  )
}

export default TreatmentResultSection
